import { render, staticRenderFns } from "./FlowerGenusList.vue?vue&type=template&id=344c3f78&"
import script from "./FlowerGenusList.vue?vue&type=script&lang=js&"
export * from "./FlowerGenusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports